const Business = {
  "rid": "1",
  "name": "Test Business",
  "type": "Business",
  "borrowerType": 'oc',
  "questions": [
    {
      "rid": 21,
      "number": 300,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description": "Were any SBA loans made to the business that are currently outstanding?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 24,
      "number": 303,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description": "Does this business have any rural locations?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 25,
      "number": 304,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description": "Does this business have any urban locations?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 32,
      "number": 311,
      "requiredAnswer": "true",
      "format": "Answer::Boolean",
      "description": "Are the products and/or services of the business available to the general public?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 33,
      "number": 312,
      "requiredAnswer": "false",
      "format": "Answer::Boolean",
      "description": "Is the <span rel=\"help\" data-title=\"&lt;p align=&quot;left&quot;&gt;The net worth (or equity) of the business less any intangible assets.&lt;/p&gt;\" data-helper=\"null\">tangible net worth</span> of the business more than $20 million?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 34,
      "number": 313,
      "requiredAnswer": "false",
      "format": "Answer::Boolean",
      "description": "Is the <span rel=\"help\" data-title=\"&lt;p align=&quot;left&quot;&gt;Net profit or after­tax income, excluding any carry­over losses.&lt;/p&gt;\" data-helper=\"null\">average net income</span> of the business after Federal income taxes (excluding any carry over losses) for the preceding two completed fiscal years more than $6.5 million?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 36,
      "number": 315,
      "requiredAnswer": "false",
      "format": "Answer::Boolean",
      "description": "Does the business engage in or is considered an ineligible business? <span rel=\"help\" data-title=\"&lt;p align=&quot;left&quot;&gt;While many small businesses from a broad range of industries can successfully apply for an SBA 7(a) loan, the Small Business Administration has a list of business types or industries that are ineligible. Ineligible businesses may be one of the following:&lt;ol&gt;&lt;li&gt;Primarily engaged in the business of lending&lt;/li&gt;&lt;li&gt;A passive business owned by developers or landlords that do not actively use or occupy the assets acquired or improved with the loan proceeds that is not an Eligible Passive Company&lt;/li&gt;&lt;li&gt;A life insurance company&lt;/li&gt;&lt;li&gt;A bail bond company&lt;/li&gt;&lt;li&gt;Located in a foreign country or owned by undocumented noncitizen&lt;/li&gt;&lt;li&gt;Have a pyramid sale distribution plan&lt;/li&gt;&lt;li&gt;Do any illegal activity&lt;/li&gt;&lt;li&gt;Principally engaged in teaching, instructing, counseling or indoctrinating religion or religious beliefs, whether in a religious or secular setting&lt;/li&gt;&lt;li&gt;A consumer or marketing cooperative&lt;/li&gt;&lt;li&gt;Earn one third or more of its gross annual revenue from packaging SBA loans&lt;/li&gt;&lt;li&gt;Derive directly or indirectly any gross revenue through the sale of products or services, or the presentation of any depiction or displays, of a prurient sexual nature or that presents any live performances of a prurient nature&lt;/li&gt;&lt;li&gt;Primarily engaged in political or lobbying activities&lt;/li&gt;&lt;li&gt;A speculative business, e.g. wildcatting, mining, and research and development&lt;/li&gt;&lt;li&gt;A pawn shop&lt;/li&gt;&lt;li&gt;A mortgage service company&lt;/li&gt;&lt;li&gt;A business primarily engaged in subdividing real property into lots and developing it for resale on its own account or in owning or purchasing real estate and leasing it for any purpose&lt;/li&gt;&lt;li&gt;A motel, RV park, campground, marina, or similar type of business that derives more than 50% of its revenue from those who stay 30 days or less at a time&lt;/li&gt;&lt;li&gt;Derive any of gross annual revenue from gambling&lt;/li&gt;&lt;li&gt;A private club&lt;/li&gt;&lt;li&gt;A government­-owned business&lt;/li&gt;&lt;/ol&gt;For the detailed list of ineligible businesses, please visit the &lt;a href=&#39;https://sba.gov/partners/lenders/7a-loan-program/terms-conditions-eligibility#section-header-19&#39;&gt;SBA.org&lt;/a&gt; website to learn more.&lt;/p&gt;\" data-helper=\"null\" data-titlepop=\"What is an ineligible business?\"></span>",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 38,
      "number": 317,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description": "Has the Small Business Applicant and/or its Affiliates ever obtained a direct or guaranteed loan from SBA or any other Federal agency or been a guarantor on such a loan?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 41,
      "number": 320,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description": "Has the Small Business Applicant and/or its Affiliates ever filed for bankruptcy protection?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 44,
      "number": 400,
      "requiredAnswer": null,
      "format": "Answer::Text",
      "description": "Describe the history of your business. What types of products and services does it provide?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "For example:  SmartBiz Loans was founded in 2009 as a result of the  financial crisis in order to help small businesses get access to affordable capital. We are backed by leading venture capital firms and are passionate about technology, finance and helping small businesses grow.",
      "selectOptions": []
    },
    {
      "rid": 45,
      "number": 401,
      "requiredAnswer": null,
      "format": "Answer::Text",
      "description": "How is your business unique? ",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "For example:  SmartBiz Loans is an advanced and secure technology platform that makes it easier and more cost effective for banks to provide loans to small businesses. The result means business owners are given fast and easy access to the low-cost funds they need to grow and flourish.",
      "selectOptions": []
    },
    {
      "rid": 46,
      "number": 402,
      "requiredAnswer": null,
      "format": "Answer::Text",
      "description": "Describe the length of time in business under current management, a brief description of the current management team, and the depth of management experience in this industry or a related industry.",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "For example:  SmartBiz Loans is based in San Francisco and was founded in 2009 by a team of experienced financial services entrepreneurs. CEO Evan Singer has led SmartBiz for 4 years. He has built a career around successfully building and growing teams, new brands, and services. Prior to SmartBiz, Evan held leadership positions as Chief Revenue Officer at Milton’s Baking, President at Purity Organic, and General Manager at Align Technology. He started his career at Procter & Gamble, and graduated with honors from Stanford University.",
      "selectOptions": []
    },
    {
      "rid": 47,
      "number": 403,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description": "Is the Small Business Applicant and/or its Affiliates presently involved in any pending legal action?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 48,
      "number": 404,
      "requiredAnswer": "false",
      "format": "Answer::Boolean",
      "description": "Is the Small Business Applicant presently suspended, debarred, proposed for debarment, declared ineligible, or voluntarily excluded from participation in this transaction by any Federal department or agency?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 49,
      "number": 405,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description": " Has the ownership of the business changed since it was founded?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 51,
      "number": 500,
      "requiredAnswer": null,
      "format": "Answer::Count",
      "description": "How many jobs will be created as a result of this loan?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 52,
      "number": 501,
      "requiredAnswer": null,
      "format": "Answer::Count",
      "description": "How many jobs will be retained as a result of this loan that would have been lost\notherwise?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 53,
      "number": 502,
      "requiredAnswer": "true",
      "format": "Answer::Boolean",
      "description": "Will the loan be used as a <span rel=\"help\" data-title=\"&lt;p align=&quot;left&quot;&gt;Do not answer yes if funds are to be used for any of the following:&lt;ul&gt; &lt;li&gt;To provide or refinance funds used for payments, distributions, or loans to associates of the business (Associates are officers, directors, owners of more than 20 percent of the equity, or key employees of the small business; any entities in which one or more of these individuals own or control at least 20 percent; or any individuals or entities in control of or controlled by the small business, except a Small Business Investment Company licensed by SBA);&lt;/li&gt; &lt;li&gt;For a purpose that will not benefit the business;&lt;/li&gt;&lt;li&gt;To provide funds for floor plan financing;&lt;/li&gt; &lt;li&gt;For debt refinancing (if borrowing $25,000 or less);&lt;/li&gt;&lt;li&gt;To fund or refinance a change in ownership;&lt;/li&gt; &lt;li&gt;For construction of (or the refinancing of the construction for) a new building;&lt;/li&gt; &lt;li&gt;To provide funds for the acquisition of land or an existing building or for renovation or reconstruction of an existing building;&lt;/li&gt; &lt;li&gt;To provide funds for or refinance leasehold improvements;&lt;/li&gt;&lt;li&gt;To provide funds to guarantee or fund a letter of credit;&lt;/li&gt; &lt;li&gt;For business acquisition.&lt;/li&gt;&lt;/ul&gt;&lt;/p&gt;\" data-helper=\"null\">working capital loan</span>, to refinance existing business debt, to purchase real estate or for business acquisition?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 54,
      "number": 504,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description": "Are any of the Small Business Applicant’s products and/or services exported or is there a plan to begin exporting as a result of this loan?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 56,
      "number": 506,
      "requiredAnswer": "false",
      "format": "Answer::Boolean",
      "description": "Has an application for the loan you are applying for now ever been submitted to SBA, or\nto a <span rel=\"help\" data-title=\"&lt;p align=&quot;left&quot;&gt;Non­profit corporations certified and regulated by the Small Business Administration to package, process, close, and service 504 loans.&lt;/p&gt;\" data-helper=\"null\">Certified Development Company</span> or lender in connection with any SBA program?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 59,
      "number": 600,
      "requiredAnswer": null,
      "format": "Answer::Dropdown",
      "description": "How soon do you need funding? <span rel=\"help\" data-title=\"&lt;p&gt;We always get you your loan as quickly as possible. Understanding your timeline for funding helps us meet your needs.&lt;/p&gt;&lt;p&gt;Our banks have multiple lending products-- and some fund faster than others. Fast funding typically means an easier application process, but higher monthly payments.&lt;/p&gt;&lt;p&gt;Your lending consultant will work with you to identify the best option for your business and needs.&lt;/p&gt;\" data-helper=\"Here&#39;s why we ask\"></span>\n",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [
        [
          "I have a strict timeline: 2 weeks or less",
          "1"
        ],
        [
          "I’m flexible: about a month works for me",
          "2"
        ],
        [
          "I don’t have a specific time in mind",
          "3"
        ]
      ]
    },
    {
      "rid": 93,
      "number": 409,
      "requiredAnswer": null,
      "format": "Answer::Count",
      "description": "Number of owners",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [],
      "children": [],
    },
    {
      "rid": 94,
      "number": 410,
      "requiredAnswer": null,
      "format": "Answer::Count",
      "description": "Number of full-time employees",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [],
      "children": [],
    },
    {
      "rid": 95,
      "number": 411,
      "requiredAnswer": null,
      "format": "Answer::Count",
      "description": "Number of part-time employees",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [],
      "children": [],
    },
    {
      "rid": 96,
      "number": 1501,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description":
        "Is any business revenue derived from gambling, loan packaging, lending activities, lobbying activities, or from the sale of products or services, or the presentation of any depiction, displays or live performances, of a prurient sexual nature?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [],
      "children": [],
    },
    {
      "rid": 97,
      "number": 1502,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description":
        "Is any employee, owner, partner, attorney, agent, owner of stock, officer, director, creditor or debtor of the Applicant a former SBA employee who has been separated from SBA for less than one year prior to the request for financial assistance?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [],
      "children": [],
    },
    {
      "rid": 98,
      "number": 1601,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description":
        "Is anyone presently suspended, debarred, proposed for debarment, declared ineligible, voluntarily excluded from participation in a transaction by any Federal department or agency",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [],
      "children": [],
    },
    {
      "rid": 99,
      "number": 1602,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description": "Is anyone presently involved in any bankruptcy?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [],
      "children": [],
    },
    {
      "rid": 100,
      "number": 1603,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description": "Has anyone ever filed for bankrupt protection?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [],
      "children": [],
    },
    {
      "rid": 102,
      "number": 1605,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description":
        "Is anyone currently delinquent or have ever defaulted on a direct or guaranteed loan from SBA, or another Federal agency loan program (including, but not limited to USDA, B&I, FSA, FHA, EDA)?",
      "parentAnswer": "true",
      "parentId": 101,
      "placeholder": "",
      "selectOptions": [],
      "children": [],
    },
    {
      "rid": 103,
      "number": 1606,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description":
        "Is anyone currently incarcerated, serving a sentence of imprisonment imposed upon adjudication of guilty, or is under indictment for a felony or any crime involving or relating to financial misconduct or a false statement?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [],
      "children": [],
    },
    {
      "rid": 104,
      "number": 1607,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description":
        "Is anyone presently involved in any legal action (including divorce)?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [],
      "children": [],
    },
    {
      "rid": 105,
      "number": 1701,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description": "Is anyone an SBA employee or a Household Member of an SBA employee?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [],
      "children": [],
    },
    {
      "rid": 106,
      "number": 1702,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description":
        "Is anyone a member of Congress, or an appointed official or employee of the legislative or judicial branch of the Federal Government?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [],
      "children": [],
    },
    {
      "rid": 107,
      "number": 1703,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description":
        "Is anyone a Federal Government employee or Member of the Military having a grade of at least GS-13 or higher (or Military equivalent)?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [],
      "children": [],
    },
    {
      "rid": 108,
      "number": 1704,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description": "Is anyone a a member or employee of a Small Business Advisory Council or a SCORE volunteer?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [],
      "children": [],
    },
    {
      "rid": 560,
      "number": 1100,
      "requiredAnswer": "false",
      "format": "Answer::Boolean",
      "description": "Has an application for the loan you are applying for now ever been submitted to SBA, or\nto a <span rel=\"help\" data-title=\"&lt;p align=&quot;left&quot;&gt;Non­profit corporations certified and regulated by the Small Business Administration to package, process, close, and service 504 loans.&lt;/p&gt;\" data-helper=\"null\">Certified Development Company</span> or lender in connection with any SBA program?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    }
  ],
  "answers": [
    {
      "questionNumber": 601,
      "value": 'true'
    }
  ],
  "guarantors": [
    {
      "questions": [
        {
          "rid": 1,
          "number": 1,
          "requiredAnswer": "false",
          "format": "Answer::Boolean",
          "description": "Are you presently subject to an indictment, criminal information, arraignment, or other means by which formal criminal charges are brought in any jurisdiction?",
          "parentAnswer": "true",
          "parentId": null,
          "placeholder": "",
          "selectOptions": []
        },
        {
          "rid": 2,
          "number": 2,
          "requiredAnswer": "false",
          "format": "Answer::Boolean",
          "description": "Have you been arrested in the past six months for any criminal offense?",
          "parentAnswer": "true",
          "parentId": null,
          "placeholder": "",
          "selectOptions": []
        },
        {
          "rid": 3,
          "number": 3,
          "requiredAnswer": null,
          "format": "Answer::Boolean",
          "description": "For any criminal offense – other than a minor vehicle violation – have you ever: 1) been convicted; 2) plead guilty; 3) plead nolo contendere; 4) been placed on pretrial diversion; or 5) been placed on any form of parole or probation (including probation before judgment)? ",
          "parentAnswer": "true",
          "parentId": null,
          "placeholder": "",
          "selectOptions": []
        },
        {
          "rid": 4,
          "number": 4,
          "requiredAnswer": "false",
          "format": "Answer::Boolean",
          "description": "Are you presently debarred, suspended, proposed for debarment, declared ineligible, or voluntarily excluded from participation in this transaction by any Federal department or Agency?",
          "parentAnswer": "true",
          "parentId": null,
          "placeholder": "",
          "selectOptions": []
        },
        {
          "rid": 5,
          "number": 5,
          "requiredAnswer": "false",
          "format": "Answer::Boolean",
          "description": "If you own 50% or more of the business, are you more than 60 days delinquent on any obligation to pay child support arising under an administrative order, court order, repayment agreement between the holder and a custodial parent, or repayment agreement between the holder and a state agency providing child support enforcement services?  If you do not own more than 50% of the business, please select no.",
          "parentAnswer": "true",
          "parentId": null,
          "placeholder": "",
          "selectOptions": []
        },
        {
          "rid": 6,
          "number": 6,
          "requiredAnswer": "true",
          "format": "Answer::Boolean",
          "description": "Are you a <span rel=\"help\" data-title=\"&lt;p align=&quot;left&quot;&gt;Any person not a citizen of the United States who is residing the in the U.S. under legally recognized and lawfully recorded permanent residence as an immigrant. Also known as &#39;Permanent Resident Alien,&#39; &#39;Resident Alien Permit Holder,&#39; and &#39;Green Card Holder.&#39;&lt;/p&gt;\">Lawful Permanent Resident alien (LPR)</span> ?",
          "parentAnswer": "true",
          "parentId": null,
          "placeholder": "",
          "selectOptions": []
        },
        {
          "rid": 11,
          "number": 18,
          "requiredAnswer": null,
          "format": "Answer::Boolean",
          "description": "Are you, or any business you control, presently involved in any legal action (including divorce)?",
          "parentAnswer": null,
          "parentId": null,
          "placeholder": "",
          "selectOptions": []
        },
        {
          "rid": 12,
          "number": 100,
          "requiredAnswer": null,
          "format": "Answer::Boolean",
          "description": "Have you or any business owned or controlled by you ever obtained a direct or guaranteed loan from SBA or any other Federal agency or been a guarantor on such a loan? (This includes student loans.)",
          "parentAnswer": "true",
          "parentId": null,
          "placeholder": "",
          "selectOptions": []
        },
        {
          "rid": 15,
          "number": 103,
          "requiredAnswer": "false",
          "format": "Answer::Boolean",
          "description": "Are you (or any stockholders with a 10 percent or more interest in the business):\n<ul><li>An SBA employee or a <span rel=\"help\" data-title=\"&lt;p align=&quot;left&quot;&gt;&lt;ul&gt;&lt;li&gt;Spouse of the individual;&lt;/li&gt;&lt;li&gt;minor children of the individual;&lt;/li&gt;&lt;li&gt;blood relatives of the individual;&lt;/li&gt;&lt;li&gt;or blood relatives of the individual’s spouse who reside in the same place of abode as the individual.&lt;/li&gt;&lt;/ul&gt;&lt;/p&gt;\">household member</span> of an SBA employee;</li>\n<li>A member of Congress, appointed official, or employee of the legislative or judicial branch of the Federal Government, or a household member of such an individual;</li>\n<li>A government employee having a grade of GS",
          "parentAnswer": "true",
          "parentId": null,
          "placeholder": "",
          "selectOptions": []
        },
        {
          "rid": 16,
          "number": 104,
          "requiredAnswer": "false",
          "format": "Answer::Boolean",
          "description": "Are any former SBA employees, who have been separated from SBA for less than one\nyear prior to the loan request, an employee, owner, partner, attorney, agent, owner of\nstock, officer, director, creditor or debtor of the business?",
          "parentAnswer": "true",
          "parentId": null,
          "placeholder": "",
          "selectOptions": []
        },
        {
          "rid": 17,
          "number": 105,
          "requiredAnswer": null,
          "format": "Answer::Boolean",
          "description": "Have you, or any business you controlled, ever filed for bankruptcy protection?",
          "parentAnswer": "true",
          "parentId": null,
          "placeholder": "",
          "selectOptions": []
        },
        {
          "rid": 18,
          "number": 210,
          "requiredAnswer": null,
          "format": "Answer::Enumerate",
          "description": "Are you a veteran of the U.S. Armed Forces?",
          "parentAnswer": "true",
          "parentId": null,
          "placeholder": "",
          "selectOptions": [
            [
              "Yes",
              "2"
            ],
            [
              "Yes - Disabled Veteran",
              "3"
            ],
            [
              "Spouse of a Veteran",
              "4"
            ],
            [
              "No",
              "1"
            ],
            [
              "Prefer not to disclose",
              "X"
            ]
          ]
        },
        {
          "rid": 19,
          "number": 220,
          "requiredAnswer": null,
          "format": "Answer::Enumerate",
          "description": "What is your ethnicity?",
          "parentAnswer": "true",
          "parentId": null,
          "placeholder": "",
          "selectOptions": [
            [
              "Hispanic or Latino",
              "H"
            ],
            [
              "Not Hispanic or Latino",
              "N"
            ],
            [
              "Prefer not to disclose",
              "Y"
            ]
          ]
        },
        {
          "rid": 20,
          "number": 230,
          "requiredAnswer": null,
          "format": "Answer::Enumerate",
          "description": "With which race(s) do you identify?",
          "parentAnswer": "true",
          "parentId": null,
          "placeholder": "",
          "selectOptions": [
            [
              "American Indian or Alaska Native",
              "1"
            ],
            [
              "Asian",
              "2"
            ],
            [
              "Black or African-American",
              "3"
            ],
            [
              "Native Hawaiian or Pacific Islander",
              "4"
            ],
            [
              "White",
              "5"
            ],
            [
              "Prefer not to disclose",
              "X"
            ]
          ]
        },
        {
          "rid": 37,
          "number": 316,
          "requiredAnswer": null,
          "format": "Answer::Boolean",
          "description": "Not including the business applying for this loan, do you own 50% or more of another business?",
          "parentAnswer": "true",
          "parentId": null,
          "placeholder": "",
          "selectOptions": []
        },
        {
          "rid": 42,
          "number": 398,
          "requiredAnswer": null,
          "format": "Answer::Count",
          "description": "How many years of management experience do you have?",
          "parentAnswer": "true",
          "parentId": null,
          "placeholder": "",
          "selectOptions": []
        },
        {
          "rid": 43,
          "number": 399,
          "requiredAnswer": null,
          "format": "Answer::Count",
          "description": "How many years have you worked in this industry?",
          "parentAnswer": "true",
          "parentId": null,
          "placeholder": "",
          "selectOptions": []
        }
      ]
    }
  ]
}

const Guarantor = {
  "rid": "1",
  "name": "Guarantor Name",
  "type": "Guarantor",
  "answers": [
    {
      "questionId": "41",
      "value": "3",
      "rid": "59740"
    },
    {
       "rid": "50907",
       "questionId": "50",
       "value": "false"
    },
    {
      "questionId": "46",
      "value": "10",
      "rid": "59741"
    }
  ],
  "questions": [
    {
      "rid": "46",
      "requiredAnswer": null,
      "format": "Answer::Count",
      "description": "How many years have you worked in this industry?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": ""
    },
    {
      "rid": 100,
      "number": 6,
      "requiredAnswer": "false",
      "format": "Answer::Boolean",
      "description": "some question?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 1,
      "number": 1,
      "requiredAnswer": "false",
      "format": "Answer::Boolean",
      "description": "Are you presently subject to an indictment, criminal information, arraignment, or other means by which formal criminal charges are brought in any jurisdiction?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 2,
      "number": 2,
      "requiredAnswer": "false",
      "format": "Answer::Boolean",
      "description": "Have you been arrested in the past six months for any criminal offense?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 3,
      "number": 3,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description": "For any criminal offense – other than a minor vehicle violation – have you ever: 1) been convicted; 2) plead guilty; 3) plead nolo contendere; 4) been placed on pretrial diversion; or 5) been placed on any form of parole or probation (including probation before judgment)? ",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 4,
      "number": 4,
      "requiredAnswer": "false",
      "format": "Answer::Boolean",
      "description": "Are you presently debarred, suspended, proposed for debarment, declared ineligible, or voluntarily excluded from participation in this transaction by any Federal department or Agency?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 5,
      "number": 5,
      "requiredAnswer": "false",
      "format": "Answer::Boolean",
      "description": "If you own 50% or more of the business, are you more than 60 days delinquent on any obligation to pay child support arising under an administrative order, court order, repayment agreement between the holder and a custodial parent, or repayment agreement between the holder and a state agency providing child support enforcement services?  If you do not own more than 50% of the business, please select no.",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 6,
      "number": 6,
      "requiredAnswer": "true",
      "format": "Answer::Boolean",
      "description": "Are you a <span rel=\"help\" data-title=\"&lt;p align=&quot;left&quot;&gt;Any person not a citizen of the United States who is residing the in the U.S. under legally recognized and lawfully recorded permanent residence as an immigrant. Also known as &#39;Permanent Resident Alien,&#39; &#39;Resident Alien Permit Holder,&#39; and &#39;Green Card Holder.&#39;&lt;/p&gt;\">Lawful Permanent Resident alien (LPR)</span> ?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 11,
      "number": 18,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description": "Are you, or any business you control, presently involved in any legal action (including divorce)?",
      "parentAnswer": null,
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 12,
      "number": 100,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description": "Have you or any business owned or controlled by you ever obtained a direct or guaranteed loan from SBA or any other Federal agency or been a guarantor on such a loan? (This includes student loans.)",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 15,
      "number": 103,
      "requiredAnswer": "false",
      "format": "Answer::Boolean",
      "description": "Are you (or any stockholders with a 10 percent or more interest in the business):\n<ul><li>An SBA employee or a <span rel=\"help\" data-title=\"&lt;p align=&quot;left&quot;&gt;&lt;ul&gt;&lt;li&gt;Spouse of the individual;&lt;/li&gt;&lt;li&gt;minor children of the individual;&lt;/li&gt;&lt;li&gt;blood relatives of the individual;&lt;/li&gt;&lt;li&gt;or blood relatives of the individual’s spouse who reside in the same place of abode as the individual.&lt;/li&gt;&lt;/ul&gt;&lt;/p&gt;\">household member</span> of an SBA employee;</li>\n<li>A member of Congress, appointed official, or employee of the legislative or judicial branch of the Federal Government, or a household member of such an individual;</li>\n<li>A government employee having a grade of GS",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 16,
      "number": 104,
      "requiredAnswer": "false",
      "format": "Answer::Boolean",
      "description": "Are any former SBA employees, who have been separated from SBA for less than one\nyear prior to the loan request, an employee, owner, partner, attorney, agent, owner of\nstock, officer, director, creditor or debtor of the business?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 17,
      "number": 105,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description": "Have you, or any business you controlled, ever filed for bankruptcy protection?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 18,
      "number": 210,
      "requiredAnswer": null,
      "format": "Answer::Enumerate",
      "description": "Are you a veteran of the U.S. Armed Forces?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [
        [
          "Yes",
          "2"
        ],
        [
          "Yes - Disabled Veteran",
          "3"
        ],
        [
          "Spouse of a Veteran",
          "4"
        ],
        [
          "No",
          "1"
        ],
        [
          "Prefer not to disclose",
          "X"
        ]
      ]
    },
    {
      "rid": 19,
      "number": 220,
      "requiredAnswer": null,
      "format": "Answer::Enumerate",
      "description": "What is your ethnicity?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [
        [
          "Hispanic or Latino",
          "H"
        ],
        [
          "Not Hispanic or Latino",
          "N"
        ],
        [
          "Prefer not to disclose",
          "Y"
        ]
      ]
    },
    {
      "rid": 20,
      "number": 230,
      "requiredAnswer": null,
      "format": "Answer::Enumerate",
      "description": "With which race(s) do you identify?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": [
        [
          "American Indian or Alaska Native",
          "1"
        ],
        [
          "Asian",
          "2"
        ],
        [
          "Black or African-American",
          "3"
        ],
        [
          "Native Hawaiian or Pacific Islander",
          "4"
        ],
        [
          "White",
          "5"
        ],
        [
          "Prefer not to disclose",
          "X"
        ]
      ]
    },
    {
      "rid": 37,
      "number": 316,
      "requiredAnswer": null,
      "format": "Answer::Boolean",
      "description": "Not including the business applying for this loan, do you own 50% or more of another business?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 42,
      "number": 398,
      "requiredAnswer": null,
      "format": "Answer::Count",
      "description": "How many years of management experience do you have?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 43,
      "number": 399,
      "requiredAnswer": null,
      "format": "Answer::Count",
      "description": "How many years have you worked in this industry?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    }
  ]
}

const SeniorStaff = {
  "rid": "1",
  "name": "SeniorStaff Name",
  "type": "SeniorStaff",
  "principal": false,
  "questions": [
    {
      "rid": 100,
      "number": 2,
      "requiredAnswer": "false",
      "format": "Answer::Boolean",
      "description": "some question?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 101,
      "number": 3,
      "requiredAnswer": "false",
      "format": "Answer::Boolean",
      "description": "some question?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    },
    {
      "rid": 102,
      "number": 5,
      "requiredAnswer": "false",
      "format": "Answer::Boolean",
      "description": "some question?",
      "parentAnswer": "true",
      "parentId": null,
      "placeholder": "",
      "selectOptions": []
    }
  ]
}

export {
  Business,
  Guarantor,
  SeniorStaff
}
